module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("OUTILS")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out",
    on: {
      "click": function($event) {
        _vm.$msal.signOut()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page",
    on: {
      "click": function($event) {
        _vm.$msal.signOut()
      }
    }
  }, [_vm._v("Déconnexion")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-256e4aae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarMenu.vue
// module id = 1337
// module chunks = 1